'use client'

import { useFullDomainUrl } from '@/hooks/use-full-domain-url'
import { gaPageView } from '@/utils/gtag'
import { useSession } from 'next-auth/react'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export function usePageViewEvent() {
  const pathname = usePathname()
  const domainUrl = useFullDomainUrl()
  const { data: session } = useSession()

  useEffect(() => {
    gaPageView({
      pageUrl: domainUrl,
      userId: session?.user.dto.id || null,
    })
  }, [pathname, domainUrl, session]) // 필요한 종속성 추가
}
